<div class="app-content vertical-scroll" cdkScrollable>
    <ssg-pay-info-table></ssg-pay-info-table>
</div>
